import { render } from "./MenuShopping.vue?vue&type=template&id=33884133&scoped=true"
import script from "./MenuShopping.vue?vue&type=script&lang=js"
export * from "./MenuShopping.vue?vue&type=script&lang=js"

import "./MenuShopping.vue?vue&type=style&index=0&id=33884133&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33884133"]])

export default __exports__